import isUsedLocalStorage from 'src/utils/isUsedLocalStorage'
import isJson from 'src/utils/isJson'

export default function useUserStorage() {
  const userStorage = {
    get(key: string) {
      if (isUsedLocalStorage()) {
        const data = localStorage.getItem(key)

        return data ? JSON.parse(data) : null
      }
    },

    set(key: string, data: unknown) {
      if (isUsedLocalStorage()) {
        localStorage.setItem(
          key,
          typeof data === 'string' && isJson(data)
            ? data as string
            : JSON.stringify(data),
        )
      }
    },

    remove(key: string) {
      if (isUsedLocalStorage()) {
        localStorage.removeItem(key)
      }
    },

    clear() {
      if (isUsedLocalStorage()) {
        localStorage.clear()
      }
    },
  }

  return {
    userStorage,
  }
}
